import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
// import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { HomeOutlined } from '@ant-design/icons';
import 'react-toastify/dist/ReactToastify.css';
import { Typography, Pagination, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';
import { Link } from 'react-router-dom';

import { globalNotifyError, globalNotifySuccess } from 'views/utilities/AlertToast';
import { handleCatchError } from 'utils/CatchHandler';
import GlobalBackButton from 'views/utilities/BackButtonGlobal';
import LinearProgress from '@mui/material/LinearProgress';
import BcConvertModal from 'views/Components/BcConvertModal';
import Spinner from 'views/Components/LoadingSinner';
import { checkMerchantOrBCAPI } from 'utils/API/Merchant APIs/MerchantApiCalls';

import { useFetchBeneficiaryList, getCustomerLimit, deleteBeneficiaryApi } from 'utils/API/Merchant APIs/UpdatedAPIs/DMTUpdatedAPICalls';
// console.log('id is :', uid);
// const senderno = localStorage.getItem('sendernumber');
const commonStyles = {
    m: 0
};
export default function DmtTransfer() {
    // const uid = localStorage.getItem('id');
    // const email = localStorage.getItem('email_id');
    const shouldshowEsign = localStorage.getItem('shouldshowEsign');
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [search, setSearch] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    const [benfDetails, setBenfDetails] = useState([]);

    const [maxLimit, setMaxLimit] = useState('');
    const [isFailed, setIsFailed] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    // const [isCreatedBenef, setisCreatedBenef] = useState(false);

    // const [customerMobile, setCustomerMobile] = useState('');
    const [isDeleted, setIsDeleted] = useState(false);
    const [benefListLoading, setBenefListLoading] = useState(false);
    const [merchantModalOpen, setMerchantModalOpen] = useState(false);
    const [isBcConvertPending, setIsBcConvertPending] = useState(false);
    const [isCheckLoading, setIsCheckLoading] = useState(true);
    const dmtType = 1;
    const data = location?.state?.item || location?.state?.data;

    const customerId = location?.state?.item?.id || location?.state?.customerId || '';

    // const createdBenficiaryStatus = location?.state?.created;
    // console.log('createdBenficiaryStatus', createdBenficiaryStatus);
    const filteredData = location?.state?.filteredData;
    const index = location?.state?.index;
    const [page, setPage] = useState(1);
    const [limit] = useState(10);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null); // to keep track of which row to delete

    const [totalCount, setTotalCount] = useState(0);

    // console.log('location.state :', location.state);
    // const agent = localStorage.getItem('id');
    // console.log(data);
    const senderno = data?.mobileNumber || location?.state?.search || localStorage.getItem('sendernumber');
    // console.log('location state is :', location?.state);
    // console.log('customers in state: ', customers);
    // console.log(index, data, filteredData);
    const getTransactionLimit = async () => {
        // console.log(agent, senderno, email, type);
        // const token = localStorage.getItem('token');
        try {
            const payload = { customerMobileNo: senderno, dmtType };
            const response = await getCustomerLimit(payload);
            // console.log('Limit response : ', response?.data?.data?.sendupto);
            const maximumLimit = response?.data?.data?.sendupto;
            setMaxLimit(maximumLimit);
        } catch (error) {
            console.log(error.message);
        }
    };

    const customerDetails = async () => {
        setBenefListLoading(true);
        try {
            // eslint-disable-next-line react-hooks/rules-of-hooks
            const response = await useFetchBeneficiaryList(2, customerId, page, limit, search);
            setBenefListLoading(false);

            if (response?.response?.status === 404) {
                globalNotifyError(response?.response?.data?.message);
            }
            const benfDetails = response?.data?.data?.result;

            setBenfDetails(Array.isArray(benfDetails) ? benfDetails : []);
            setTotalCount(response?.data?.data?.pagination?.totalCount || 0);
            getTransactionLimit();
        } catch (error) {
            // console.log('errorResponse', error?.response?.status);
            // if (error?.response?.status === 404) {
            //     globalNotifyError(error?.response?.data?.message);
            // }
            // setBenefListLoading(false);
            // handleCatchError(error);
        }
    };
    useEffect(() => {
        // if (search.length >= 3 || search.length === 0) {
        setPage(1); // Reset to first page
        // }
        // eslint - disable - next - line;
    }, [search]);

    useEffect(() => {
        // if (search.length >= 3 || search.length === 0) {
        customerDetails(); // Call API only if valid search or clearing search
        // }

        //    eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, search]);
    function addbeneficiary() {
        // console.log('sendernumber to local storage', senderno);
        localStorage.setItem('sendernumber', senderno);
        navigate('/moneyTransfer1/createBeneficiary', { state: { customerId, data, senderno } });
    }
    function ListBeneficiary() {
        navigate('/moneyTransfer1/listAllBeneficiary', { state: { data, senderno } });
    }
    function ListMoneyTransfer() {
        navigate('/moneyTransfer1/listMoneyTransfer', { state: { data, senderno } });
    }
    const handleBcModalClose = () => {
        setMerchantModalOpen(false);
    };

    const handleTransferClick = (row, indexBenef) => {
        //This function triggers when transfer button is clicked
        // console.log('sendernumber to local storage - transfer click', senderno);
        localStorage.setItem('sendernumber', senderno);
        // console.log(data.customermob);
        // console.log('data in fn', benfDetails);
        navigate('/moneyTransfer1/moneyTransfer', { state: { data, row, filteredData, index, indexBenef, senderno, customerId } });
    };

    // useEffect(() => {
    //     if (isFailed) {
    //         notify();
    //     }
    //     if (isSuccess) {
    //         customerNotify();
    //     }
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [isFailed, isSuccess]);
    useEffect(() => {
        if (isFailed) {
            globalNotifyError(isFailedMessage);
        }
        if (isSuccess) {
            globalNotifySuccess(isSuccessMessage);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isFailed, isSuccess]);

    // useEffect(() => {
    //     if (isCreatedBenef === 1) {
    //         // benefCreateSuccessNotify();
    //         globalNotifySuccess('Beneficiary added successfully !');
    //     }
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [isCreatedBenef]);
    // useEffect(() => {
    //     setisCreatedBenef(createdBenficiaryStatus);
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [createdBenficiaryStatus]);

    // const handleOk = () => {
    //     setModalText('The modal will be closed after two seconds');
    //     setConfirmLoading(true);
    //     deleteBeneficiary();
    // };
    // const handleCancel = () => {
    //     setOpen(false);
    // };
    //Delete Beneficiary >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>

    const deleteBeneficiary = async (row) => {
        // const token = localStorage.getItem('token');

        setIsFailed(false);
        setIsSuccess(false);
        setIsDeleted(false);
        try {
            const payload = {
                beneMob: row?.mobileNumber,
                ifscCode: row?.ifscCode,
                accountno: row?.accountNumber,
                beneId: row?.id,
                agentId: String(2)
            };

            const response = await deleteBeneficiaryApi(payload);
            // setOpen(false);
            // setConfirmLoading(false);
            customerDetails();

            if (response?.data?.success) {
                globalNotifySuccess(response?.data?.message);
                setIsDeleted(true);
                // setIsSuccessMessage(response?.data?.message);
            }
            // console.log('delete response', response);
        } catch (error) {
            console.log(error.message);
            handleCatchError(error);
        }
    };

    useEffect(() => {
        if (customerId) {
            customerDetails();
        }
        const checkIsMerchantOrBc = async () => {
            //CHECKING FOR  MERCHANT OR BC
            setIsCheckLoading(true);
            const agentid = localStorage.getItem('id');

            const payloadCheck = { agentid };
            const merchantBcCheckResponse = await checkMerchantOrBCAPI(payloadCheck);
            setIsCheckLoading(false);
            // const globalMerchantPermission = useSelector((state) => state);
            // console.log('globalMerchantPermission', globalMerchantPermission);
            const agentType = merchantBcCheckResponse?.data?.agentType;
            const pendingStatus = merchantBcCheckResponse?.data?.isPending;
            setIsBcConvertPending(pendingStatus);

            if (agentType === 'Merchant' || pendingStatus || shouldshowEsign === 'true') {
                setMerchantModalOpen(true);

                return;
            }
            //CHECKING ENDS HERE
        };
        checkIsMerchantOrBc();
        // If search changes, reset to page 1 only
        if (search) {
            setPage(1);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customerId, page, limit, isDeleted, search]);
    useEffect(() => {
        if (customerId) {
            customerDetails();
        }
        // eslint-disable-next-line
    }, [customerId, page, limit, isDeleted]);
    // console.log('customerId', customerId);

    const handleChange = (e) => {
        const input = e.target.value;
        // const capitalized = input.replace(/\b\w/g, (char) => char.toUpperCase());
        setSearch(input);
    };

    return (
        <>
            <div>
                {/* <Box sx={{ '& > :not(style)': { m: 1, mb: 4 } }}>
                    <Fab variant="extended" size="small" color="primary" aria-label="add" onClick={handleBack}>
                        <ArrowBackIcon sx={{ mr: 1 }} />
                    </Fab>
                </Box> */}
                {/* <<<<<<<Breadcrumb starts here>>>>>> */}
                <Box
                    sx={{
                        width: '100%',
                        height: 'auto',
                        backgroundColor: '#fff',
                        ...commonStyles,
                        borderRadius: 2,
                        marginBottom: 2,
                        padding: '20px 10px',
                        '@media screen and (min-width: 600px)': {
                            padding: 2
                        }
                    }}
                >
                    <Typography variant="h3">
                        <GlobalBackButton />
                        Domestic Money Transfer
                    </Typography>

                    <Box sx={{ marginTop: '10px' }}>
                        <Link to="/merchant-home" style={{ textDecoration: 'none', color: 'inherit' }}>
                            <HomeOutlined />
                        </Link>

                        <Typography component="span" style={{ margin: '0 10px' }}>
                            &gt;
                        </Typography>

                        <Link to="/moneyTransfer1/viewCustomers" state={{ data }} style={{ textDecoration: 'none', color: 'inherit' }}>
                            <Typography component="span">View Customer</Typography>
                        </Link>
                    </Box>
                </Box>
                {/* <<<<<<<Breadcrumb end here>>>>>>> */}
                <TableContainer component={Paper}>
                    <Table aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Name : {data?.customerName}</TableCell>
                                {!isMobile && (
                                    <TableCell align="right">
                                        KYC : {data?.ekycStatus === false ? 'KYC Not Applied' : 'KYC Applied'}
                                    </TableCell>
                                )}
                                {!isMobile && <TableCell align="right">Mobile :{data?.mobileNumber}</TableCell>}
                                {!isMobile && <TableCell align="right">MONTHLY LIMIT :{maxLimit ? maxLimit : '0'}</TableCell>}
                            </TableRow>
                        </TableHead>
                    </Table>
                </TableContainer>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Button color="primary" variant="contained" disableElevation sx={{ m: 2 }} onClick={() => addbeneficiary()}>
                        Add Beneficiary
                    </Button>
                    <Button color="primary" variant="contained" disableElevation sx={{ m: 2 }} onClick={() => ListBeneficiary()}>
                        List All Beneficiaries
                    </Button>
                    <Button color="primary" variant="contained" disableElevation sx={{ m: 2 }} onClick={() => ListMoneyTransfer()}>
                        List moneyTransfer
                    </Button>
                    <Stack direction="row" spacing={2} sx={{ mb: 1 }}>
                        <TextField
                            label="Search with Beneficiary Name"
                            name="search"
                            value={search}
                            onChange={handleChange}
                            variant="outlined"
                        />
                    </Stack>
                </div>
                <TableContainer component={Paper}>
                    {benefListLoading ? (
                        <Box sx={{ width: '100%' }}>
                            <LinearProgress />
                        </Box>
                    ) : (
                        <Table size={isMobile ? 'small' : 'medium'} aria-label="a dense table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Sl. No</TableCell>
                                    <TableCell align="right">Beneficiary Name</TableCell>
                                    <TableCell align="right">IFSC</TableCell>
                                    <TableCell align="right">Account Number</TableCell>
                                    <TableCell align="right">Mobile Number</TableCell>
                                    <TableCell align="center"></TableCell>
                                    <TableCell align="center"></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {benfDetails.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={6} align="center">
                                            No Data Available
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    benfDetails.map((row, index) => (
                                        <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell>{(page - 1) * limit + index + 1}</TableCell>{' '}
                                            <TableCell align="right">
                                                {row?.beneNamePrefix + ' ' + row?.beneficiaryFirstName + ' ' + row?.beneficiaryLastName}
                                            </TableCell>
                                            <TableCell align="right">{row.ifscCode}</TableCell>
                                            <TableCell align="right">{row.accountNumber}</TableCell>
                                            <TableCell align="right">{row.mobileNumber}</TableCell>
                                            <TableCell align="center">
                                                <Button
                                                    color="primary"
                                                    variant="contained"
                                                    size={isMobile ? 'small' : 'medium'}
                                                    onClick={() => {
                                                        handleTransferClick(row, row.id);
                                                    }}
                                                >
                                                    Transfer
                                                </Button>
                                            </TableCell>
                                            <TableCell align="center">
                                                <Button
                                                    style={{ marginLeft: '10px' }}
                                                    color="error"
                                                    variant="contained"
                                                    size={isMobile ? 'small' : 'medium'}
                                                    onClick={() => {
                                                        setSelectedRow(row);
                                                        setOpenDeleteDialog(true);
                                                    }}
                                                >
                                                    Delete
                                                </Button>
                                            </TableCell>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    )}
                </TableContainer>
                <Pagination
                    count={Math.ceil(totalCount / limit)}
                    page={page}
                    onChange={(e, value) => setPage(value)}
                    color="primary"
                    sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}
                />
                {merchantModalOpen && (
                    <BcConvertModal
                        isOpen={merchantModalOpen}
                        handleclose={handleBcModalClose}
                        isPending={isBcConvertPending}
                        serviceName={'dmt'}
                        shouldshowEsign={shouldshowEsign}
                    />
                )}

                <Spinner loading={isCheckLoading} />
            </div>
            <Dialog open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)}>
                <DialogTitle sx={{ fontSize: '1.2rem' }}>Delete Beneficiary</DialogTitle>
                <DialogContent>
                    <DialogContentText sx={{ fontWeight: 500, color: 'black' }}>
                        Are you sure you want to delete this beneficiary?
                        <br />
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDeleteDialog(false)} color="primary">
                        Cancel
                    </Button>
                    <Button
                        onClick={() => {
                            deleteBeneficiary(selectedRow); // 👈 Use selectedRow here
                            setOpenDeleteDialog(false);
                        }}
                        color="error"
                        variant="contained"
                    >
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
